import { useMatches } from "react-router"

export default function useParentData<T>(
  pathname: string,
  id?: string,
  key?: string
): T | null {
  const matches = useMatches()
  let parentMatch
  if (id) {
    parentMatch = matches.find((match) => match.id === id)
  } else {
    parentMatch = matches.find((match) => match.pathname === pathname)
  }
  if (!parentMatch) return null
  return (
    key ? (parentMatch.loaderData as any)?.[key] : parentMatch.loaderData
  ) as T
}
